import { useContext } from "react";
import UserContext from "../../context/UserContext";
function UserData({ userInfo }) {
  const { userData } = useContext(UserContext);
  const { email, role, name, createdAt } = userData;
  return (
    <>
      <div className="flex justify-start items-center w-4/5 gap-8">
        <i class="fa-solid fa-circle-user text-5xl sm:text-9xl  md:text-9xl  lg:text-9xl  xl:text-9xl  text-custom-blue "></i>
        <div>
          <h1 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl ">
            {name}
          </h1>
          <h2>{email}</h2>
          <p className="text-sm">Created at {createdAt} </p>
        </div>
      </div>
      {role !== "admin" && (
        <ul className="flex flex-col flex-wrap text-base leading-5 p-2 dark:bg-slate-800 bg-slate-300 w-4/5  gap-3 rounded-md ">
          {/* <li className="flex  flex-row justify-between p-5 dark:bg-slate-700 bg-slate-200 items-center rounded-md w-auto">
          <p>Cy Ganderton</p>
        </li> */}

          {userInfo &&
            userInfo.map((info) => {
              return (
                <li
                  key={info.name}
                  className="flex  flex-row justify-between p-5 dark:bg-slate-700 bg-slate-200 items-center rounded-md"
                >
                  {info.isSet ? (
                    <>
                      <p className="font-bold">{info.name}:</p>{" "}
                      <p>{info.value}</p>{" "}
                    </>
                  ) : (
                    <div className="join ">
                      <input
                        className="input input-bordered join-item w-full"
                        placeholder={info.name}
                      />
                      <button className="btn join-item rounded-r-full">
                        Save
                      </button>
                    </div>
                  )}
                </li>
              );
            })}
          {/* <li className="flex  flex-row justify-between p-5 dark:bg-slate-700 bg-slate-200 items-center rounded-md w-full">
          <div className="join ">
            <input
              className="input input-bordered join-item w-full"
              placeholder="Email"
            />
            <button className="btn join-item rounded-r-full">Subscribe</button>
          </div>
        </li> */}
        </ul>
      )}
    </>
  );
}

export default UserData;
